import { useState, useEffect } from 'react';

// Matches Tailwind CSS default breakpoints exactly
const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
};

function getBreakpoint() {
  if (typeof window === 'undefined') return 'lg'; // SSR-safe default
  const w = window.innerWidth;
  if (w < BREAKPOINTS.sm) return 'xs';
  if (w < BREAKPOINTS.md) return 'sm';
  if (w < BREAKPOINTS.lg) return 'md';
  if (w < BREAKPOINTS.xl) return 'lg';
  return 'xl';
}

export default function useBreakpoint() {
  const [breakpoint, setBreakpoint] = useState(getBreakpoint);

  useEffect(() => {
    // Create matchMedia queries for each Tailwind breakpoint
    const queries = [
      window.matchMedia(`(min-width: ${BREAKPOINTS.xl}px)`),
      window.matchMedia(`(min-width: ${BREAKPOINTS.lg}px)`),
      window.matchMedia(`(min-width: ${BREAKPOINTS.md}px)`),
      window.matchMedia(`(min-width: ${BREAKPOINTS.sm}px)`),
    ];

    const handleChange = () => setBreakpoint(getBreakpoint());

    queries.forEach((mq) => mq.addEventListener('change', handleChange));
    return () => {
      queries.forEach((mq) => mq.removeEventListener('change', handleChange));
    };
  }, []);

  return {
    breakpoint,
    isMobile: breakpoint === 'xs' || breakpoint === 'sm',
    isTablet: breakpoint === 'md',
    isDesktop: breakpoint === 'lg' || breakpoint === 'xl',
    isLargeDesktop: breakpoint === 'xl',
  };
}
